import { render, staticRenderFns } from "./TaskLogView.vue?vue&type=template&id=135aa648"
import script from "./TaskLogView.vue?vue&type=script&lang=js"
export * from "./TaskLogView.vue?vue&type=script&lang=js"
import style0 from "./TaskLogView.vue?vue&type=style&index=0&id=135aa648&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports